import { Button } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

import { useTranslation } from 'react-i18next'
import { variantStyles } from '~/theme/constants'
import { closeModalDropdown } from '../../../redux/modalDropDownSlice'
import { path } from '../../../routes/path'
import { servingRequest } from '../callStaffSlice'
import _ from 'lodash'
import useIsTablet from '~/hooks/useIsTablet'

const ButtonCallStaff = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isTablet = useIsTablet()

  const callStaffHandler = () => {
    dispatch(servingRequest())
    if (isTablet) {
      navigate(path.callStaffTablet)
    } else {
      navigate(path.callStaff)
    }
    dispatch(closeModalDropdown())
  }

  const debounceCallStaff = _.debounce(() => {
    callStaffHandler()
  }, 200)

  return (
    <Button
      padding={isTablet ? '20px 12px' : '3px 8px'}
      onClick={debounceCallStaff}
      style={styles.btnCallStaff}
      variant={variantStyles.btnAddToOrder}>
      {t('actions.call_staff')}
    </Button>
  )
}

export default React.memo(ButtonCallStaff)

const styles = {
  btnCallStaff: {
    width: '100%',
    borderRadius: 96,
    fontSize: '2rem',
    fontWeight: '600',
    padding: '3px 8px',
  },
}
